import React from "react";
import ReactGA from 'react-ga';
import Link from "react-router-dom/Link";
import Page from "../Page";
import restartSVG from "img/restart.svg";
import tearPads2 from "img/tear-pads2.png";
import check from "img/check.svg";

export default function Solution({ resetData }) {
  ReactGA.pageview('/solution/1')
  return (
    <Page>
      <div className="solution-page">
        <div className="introduction-page__restart-block">
          <ul className="arrival-page__arms-list">
            <li>A</li>
            <li className="full-word">Replenish</li>
            <li>M</li>
            <li>S</li>
          </ul>
          <Link
            to={{ pathname: "/login", state: { prev: true } }}
            className="introduction-page__restart-btn"
            href="#"
            onClick={resetData}
          >
            <img
              className="introduction-page__restart-icon"
              src={restartSVG}
              alt=""
            />
            <span>Restart</span>
          </Link>
        </div>
        <div className="problem-page__main-section">
          <div className="problem-page__image-container">
            <img className="problem-page__image" src={tearPads2} alt="" />
          </div>
          <div className="problem-page__investigate-block">
            <img className="problem-page__bang-circle" src={check} alt="" />
            <h1>Replenish Tear Pads Regularly</h1>
            <p>
              Don’t wait until you run out! It’s important to ensure all pick
              ticket SKUs and locations have at least one pad. Partner with MET to
              reorder tear pads and avoid lost sales.
            </p>
            <p className="bold">
              Our customer is ready to take the tear pad sheet to the front and
              checkout.
            </p>
            <Link to="/problem/2" className="btn login-page__start-btn">
              <span className="white-background">To the register</span>
            </Link>
          </div>
        </div>
      </div>
    </Page>
  );
}
